import axios from "axios";
import request from 'axios';
import Environment from "./Environment";
import type { Mentor } from "../models/Mentor";

interface PaginatedResponse<T> {
    count: number;
    next: string | null;
    previous: string | null;
    results: T[];
}

interface AvailableSlotsResponse {
    status: string;
    data: {
        [date: string]: Array<{ start: string }>;
    };
}

interface ReservationResponse {
    message: string;
    reservation_uid: string;
    price_with_tax: number;
    session_id: string;
}

interface ConfirmReservationResponse {
    message: string;
    booking_uid: string;
}

class MentorshipAPI {
    static mentorshipAPIUrl = `${Environment.apiUrl}/mentorship`;
    static mentorshipSesssionAPIUrl = `${Environment.apiUrl}/mentorship/sessions`;
    static mentorshipPaymentAPIUrl = `${Environment.apiUrl}/mentorship/payment`;
    static mentorshipCodeAPIUrl = `${Environment.apiUrl}/mentorship/codes`;

    static listMentors = async (path: string = ''): Promise<{ data: PaginatedResponse<Mentor> }> => {
        const response = await axios.get(`${this.mentorshipAPIUrl}/mentors/${path}`);
        return response;
    };
    static createMentor = (user: number) => {

        const apiCompletionPromise = request({
            method: 'post',
            data: {user},
            url: `${MentorshipAPI.mentorshipAPIUrl}/mentors/`,
        });

        return apiCompletionPromise;
    };

    static patchMentor = ({mentor}: ({mentor: Partial<Mentor>})) => {
        
        // user and id shouldn't be passed in the patch request
        const { id, user, ...data } = mentor;
        const apiCompletionPromise = request({
            method: 'patch',
            data,
            url: `${MentorshipAPI.mentorshipAPIUrl}/mentors/${id}/`,
        });

        return apiCompletionPromise;
    };
    
    static getAvailableSlots = async (mentor: Mentor): Promise<AvailableSlotsResponse> => {
        const response = await axios.get(
            `${this.mentorshipAPIUrl}/mentors/${mentor.id}/get-available-slots/`
        );
        
        return {
            status: 'success',
            data: response.data
        };
    };
    
    static makeReservation = async (params: {
        mentor: Mentor,
        start_slot: string,
    }): Promise<ReservationResponse> => {
        const { mentor, start_slot } = params;
            
            const response = await axios.post(
                `${this.mentorshipAPIUrl}/mentors/${mentor.id}/make-reservation/`,
                {
                    start_slot
                }
            );
            
        return response.data;
    };
    
    static confirmReservation = async (params: {
        sessionId: string,
        paymentEmail?: string,
        discountCode?: string
    }): Promise<ConfirmReservationResponse> => {
        const { sessionId, paymentEmail, discountCode } = params;
            
            if (!paymentEmail && !discountCode) {
                throw new Error('Either payment email or discount code is required');
            }
            
            const payload: any = {};
            if (paymentEmail) {
                payload.payment_email = paymentEmail;
            }
            if (discountCode) {
                payload.discount_code = discountCode;
            }
            
            const response = await axios.post(
                `${this.mentorshipSesssionAPIUrl}/${sessionId}/confirm-reservation/`,
                payload
            );
            
            return response.data;
    };
    
    static createMentorshipSession = ({mentor, mentee, discountcode_set, duration}:
         ({mentor: string, mentee: number, discountcode_set?:Array<string>, duration: any})) => {

        const apiCompletionPromise = request({
            method: 'post',
            data: {mentor, mentee, discountcode_set, duration},
            url: `${MentorshipAPI.mentorshipSesssionAPIUrl}/`,
        });

        return apiCompletionPromise;
    };

    static sessionScheduled = (id: string, event_details: any) => {
        
        const apiCompletionPromise = request({
            method: 'post',
            data: {event_details},
            url: `${MentorshipAPI.mentorshipAPIUrl}/sessions/${id}/scheduled/`,
        });

        return apiCompletionPromise;
    };

    static verifyDiscountCode = ({code}: ({code: string})) => {

        const apiCompletionPromise = request({
            method: 'post',
            data: {code},
            url: `${MentorshipAPI.mentorshipCodeAPIUrl}/verify/`,
        });

        return apiCompletionPromise;
    };
    
    static verifyPayment = ({email, mentorshipSessionId}: {email: string, mentorshipSessionId: string}) => {
        const apiCompletionPromise = request({
            method: 'post',
            data: {email, mentorship_session_id: mentorshipSessionId},
            url: `${MentorshipAPI.mentorshipPaymentAPIUrl}/verify/`,
        });

        return apiCompletionPromise;
    };

    static getBookings = (username: string = 'Test123') => {
        const apiCompletionPromise = request({
            method: 'get',
            url: `${MentorshipAPI.mentorshipSesssionAPIUrl}/bookings/?username=${username}`,
        });

        return apiCompletionPromise;
    };
}

export default MentorshipAPI; 